import React from "react";
import { Link, useLocation } from "react-router-dom";
import { 
  LayoutDashboard, 
  Users, 
  FileCheck, 
  Upload,
  LogIn,
  LogOut,
  Building2
} from "lucide-react";
import { cn } from "@/lib/utils";

const PartnerSidebarNav: React.FC = () => {
  const location = useLocation();

  // Em produção, viria do contexto de autenticação
  const companyData = {
    name: localStorage.getItem("partnerCompanyName") || "Empresa",
    type: localStorage.getItem("partnerCompanyType") || "aviation", // "aviation" | "hotel" | "sports"
    cnpj: localStorage.getItem("partnerCNPJ") || ""
  };

  const menuItems = [
    {
      title: "Dashboard",
      icon: LayoutDashboard,
      href: "/partner/dashboard",
    },
    {
      title: "Operações",
      icon: companyData.type === "hotel" ? LogIn : Upload,
      href: "/partner/operations",
      badge: companyData.type === "hotel" ? "Check-in" : "Upload Voos"
    },
    {
      title: "Meus Beneficiários",
      icon: Users,
      href: "/partner/beneficiaries",
    },
    {
      title: "Certificados",
      icon: FileCheck,
      href: "/partner/certificates",
    },
  ];

  const handleLogout = () => {
    // Limpar dados da sessão
    localStorage.removeItem("partnerToken");
    localStorage.removeItem("partnerCompanyId");
    localStorage.removeItem("partnerCompanyName");
    localStorage.removeItem("partnerCompanyType");
    localStorage.removeItem("partnerCNPJ");
    window.location.href = "/";
  };

  return (
    <div className="flex flex-col h-full text-white">
      {/* Logo/Header */}
      <div className="flex flex-col items-start p-6 border-b border-blue-600">
        <h2 className="text-xl font-bold text-white mb-1">{companyData.name.split(' ')[0]}</h2>
        <p className="text-xs text-blue-100">Painel de Gestão</p>
      </div>

      {/* Menu Items */}
      <nav className="flex-1 p-4 space-y-1">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.href;
          
          return (
            <Link
              key={item.href}
              to={item.href}
              className={cn(
                "flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors",
                isActive
                  ? "bg-white text-[#0e7cb4]"
                  : "text-white hover:bg-blue-600"
              )}
            >
              <Icon className="h-5 w-5" />
              <span className="flex-1">{item.title}</span>
            </Link>
          );
        })}
      </nav>

      {/* Footer com Avatar e Logout */}
      <div className="p-4 border-t border-blue-600">
        <div className="flex items-center gap-3 mb-3">
          <div className="h-10 w-10 rounded-full bg-white flex items-center justify-center">
            <span className="text-[#0e7cb4] font-bold text-sm">
              {companyData.name.charAt(0).toUpperCase()}
            </span>
          </div>
          <div className="flex-1">
            <p className="text-sm font-medium text-white">{companyData.name}</p>
          </div>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full px-3 py-2 rounded-lg text-sm font-medium text-white hover:bg-blue-600 transition-colors"
        >
          <LogOut className="h-5 w-5" />
          <span>Sair</span>
        </button>
      </div>
    </div>
  );
};

export default PartnerSidebarNav;
